import React, { useEffect, useState, useRef } from 'react';
import icone from '../../assets/images/info.png';
import icone2 from '../../assets/images/coeur.png';
import Img from '../../assets/images/c4.png';
import { useLocation, useNavigate } from "react-router-dom";
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CTab,
  CTabContent,
  CTabList,
  CTabPanel,
  CTabs,
  CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react'
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaEllipsisV, FaEdit } from "react-icons/fa";
import api from '../../service/caller';
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import Adminprofil from '../../assets/images/adminprofil.png';
import { ToastContainer, toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Table } from 'react-bootstrap';
import Solution from './solution';


const Rooms = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('unassigned'); // Default "unassigned"
  const [showaddroom, setAddroomShow] = useState(false);
  const [showaddbed, setAddbedShow] = useState(false);
  const [UserData, setUserData] = useState([]);
  const [rooms, setRooms] = useState([]); // State for fetched rooms
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);

  // Adding a state for selected room
  const [selectedRoom, setSelectedRoom] = useState(null); // This will store the selected room

  const handlePrescriptionClose = () => setShowPrescriptionModal(false);
  const handlePrescriptionShow = () => setShowPrescriptionModal(true);

  const handleAddroomClose = () => setAddroomShow(false);
  const handleAddroomShow = () => setAddroomShow(true);

  const handleAddbedClose = () => setAddbedShow(false);
  const handleAddbedShow = () => setAddbedShow(true);

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  useEffect(() => {
    const fetchRooms = async () => {
      if (UserData && UserData.hospital_id && UserData.hospital_id._id) {
        try {
          let hospitalId = UserData.hospital_id._id;
          const response = await api.get(`/api/getrooms/${hospitalId}`);
          setRooms(response.data); // Set rooms to state
        } catch (error) {
          console.log("Error fetching rooms:", error);
          toast.error("Failed to fetch rooms data");
        }
      }
    };

    if (UserData && UserData.hospital_id) {
      fetchRooms();
    }
  }, [UserData]);

  // Handle room assignment
  const handleAssignPatient = (room) => {
    setSelectedRoom(room);  // Set the selected room when a user clicks on a room to assign
    setShowPrescriptionModal(true);  // Show the prescription modal
  };

  // modal
  const [show, setShow] = useState(false);
  const [shows, setShows] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloses = () => setShows(false);
  const handleShows = () => setShows(true);

  return (
    <div className="py-4">
      <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
        <div className="hosp-header__content">
          {/* Titre à gauche */}
          <div className="hosp-header__title">
            <h4 className="hosp-page__title"><b>Room Management</b></h4>
          </div>

          {/* Profil utilisateur à droite */}
          <div className="hosp-user__profile">
            {/* Indicateur de statut en ligne (optionnel) */}
            <div className="hosp-status__indicator"></div>

            <img
              src={UserData?.picture || Adminprofil}
              className='hosp-profile__image'
              alt="Profile Icon"
            />

            <div className="hosp-user__details">
              <span className="hosp-user__name">{UserData.firstname} {UserData.lastname}</span>
              <p className="hosp-user__role">
                {UserData.role?.name}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='mt-3'>
        <CRow>
          <CCol xs={12}>
            <CCard className="card mb-4 p-4">
              <Solution />
            </CCard>
          </CCol>
        </CRow>
      </div>

    </div>
  );
};

export default Rooms;
